import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { buildFunnelPath, resolveStepSlug } from '../../../lib/funnelPublicApi';

export default function CTABlock({ content = {}, slug, steps }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleClick = () => {
    if (content.use_booking) {
      const el = document.getElementById('funnel-booking-block');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    if (content.url?.trim()) {
      window.open(content.url.trim(), '_blank', 'noopener,noreferrer');
      return;
    }

    const targetSlug = resolveStepSlug(steps, content.target_step);
    if (targetSlug && slug) {
      navigate(buildFunnelPath(slug, targetSlug, searchParams));
    }
  };

  if (!content.button_text) return null;

  return (
    <section className="py-6 px-4 sm:px-0">
      <div className="flex justify-center">
        <button
          type="button"
          onClick={handleClick}
          className="w-full sm:w-auto min-w-[240px] px-8 py-4 rounded-lg text-lg font-semibold transition-opacity hover:opacity-90 shadow-sm"
          style={{
            backgroundColor: content.background_color || '#00AAFF',
            color: content.text_color || '#ffffff',
          }}
        >
          {content.button_text}
        </button>
      </div>
    </section>
  );
}
